export default {
  'create': 'Zamówienie utworzone',
  'email-confirm': 'Email potwierdzający zamówienie',
  'payment': 'Zamówienie opłacono',
  'email-paid': 'Email potwierdzający płatność',
}
